/*
 * @version: V1.0.0
 * @Date: 2023-07-06 10:08:09
 * @LastEditors: lzq
 * @LastEditTime: 2023-10-11 15:44:26
 * @company: 睿展数据
 * @FilePath: \udi-web\src\api\system\operate.js
 * @Descripttion:
 */
import request from '@/utils/request'

// 查询操作记录列表
export function getOperateList(params) {
  return request({
    url: '/wmsBusiLog/list',
    method: 'post',
    params
  })
}